interface IconProps {
  className?: string;
}

const AlignLeftIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-4 h-4"}
      {...rest}
    >
      <g clipPath="url(#clip0_12629_159502)">
        <path
          fill="currentColor"
          d="M2.016 3.375a.75.75 0 0 1 .75-.75h12.468a.75.75 0 0 1 0 1.5H2.766a.75.75 0 0 1-.75-.75m0 11.25a.75.75 0 0 1 .75-.75h7.812a.75.75 0 0 1 0 1.5H2.766a.75.75 0 0 1-.75-.75m0-3.75a.75.75 0 0 1 .75-.75h12.468a.75.75 0 0 1 0 1.5H2.766a.75.75 0 0 1-.75-.75m0-3.75a.75.75 0 0 1 .75-.75h7.812a.75.75 0 0 1 0 1.5H2.766a.75.75 0 0 1-.75-.75"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_12629_159502">
          <path fill="#fff" d="M0 0h18v18H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default AlignLeftIcon;
